
import { useSelector, useDispatch } from 'react-redux'
import { guest_close_vk_extern, unset_updatemeeting} from '../app/slice/mainslice'
import { Logout,   } from 'tabler-icons-react';
import { Text, Title, Grid, Group, Avatar,Indicator,createStyles, rem, Modal, Button, Tooltip} from '@mantine/core';
import { Video } from 'tabler-icons-react';
import { useState } from 'react';
import intl from 'react-intl-universal';
import ClientChangeLanguage from '../app/helperforall/ClientChangeLanguage';


const useStyles = createStyles((theme) => ({
    padtop10: {
      paddingTop: `10px`,
    },
  }));


/**
 * Renders the GuestToolsView component.
 * 
 * Sidebar with UserInMeeting
 *
 * @meuser: {Object} - state.user.meuser - The current user.
 * @meetinguser: {Object} - state.user.meetinguser - The current meeting user.
 * @meetinginfo: {Object} - state.user.meetinginfo - The current meeting information.
 * 
 * @return {JSX.Element} The rendered component.
 */
const GuestToolsView = (props: any) => {
    const { classes } = useStyles();
    const dispatch = useDispatch()
    const meuser = useSelector((state: any) => state.user.guest_meinfo)
    const meetinguser = useSelector((state: any) => state.user.guest_meeting_participants)
    const meetinginfo = useSelector((state: any) => state.user.guest_meetinginfo)

    const [logoutopened, setLogoutopened] = useState(false);

    const closemessage = () => {
      dispatch(unset_updatemeeting())
    }

   /* let a = meuser.lastName.substring(0,1)
    let b = meuser.firstName.substring(0,1)
    let initialen = b + a
    let fullname = meuser.lastName + " " + meuser.firstName */

    let initialen = "GU"
    let fullname = meuser.emailAddress

    /**
     * A function that handles the logout process by setting 'logoutopened' to true.
     *
     * @return {void} 
     */
    const handleLogout = () => {
      setLogoutopened(true);
      
    };

  /**
   * Sets the state of `logoutopened` to `false`, closing the logout modal.
   *
   * @return {void} 
   */
    const handleLogoutclose = () => {
      setLogoutopened(false);
    };
  

  /**
   * Handles the click event when the user confirms the logout.
   * Sends a request to the server to close the meeting.
   * closes the logout modal.
   * @return {void} .
   */
    const handleLogoutYesClick = () => {
      dispatch(guest_close_vk_extern())
      handleLogoutclose();
    };
  
    /**
     * A description of the entire function.
     * closes the logout modal.
     * @return {type} 
     */
    const handleLogoutNoClick = () => {
      handleLogoutclose();
    };   

  /**
   * Sends a logout command to close the current document in SignalR
   * @return {void} 
   */
    const sentlogoutcommand = () => {
      const handlelogoutpayload = {
        drnId: meetinginfo.drnId,
        command: "closedoc"   
      }; 
      dispatch({ type: 'SIGNALR_SENDCLOSEMEETING', payload: handlelogoutpayload });
    }
    //console.log(meetinguser)
    // Status Abzeige Online UserMe ()
    const meuserstatus = meetinguser.filter((obj: { id: any; }) => {
    return obj.id === meuser.id
    });

    //console.log(meuserstatus)
  
    let userstatuscolor = "red";
    if (meuserstatus && meuserstatus.length > 0) {
      if(meuserstatus[0].meetingParticipantStatus === "LeftMeeting") {
        userstatuscolor = "red";
      }
      if(meuserstatus[0].meetingParticipantStatus === "InMeeting") {
        userstatuscolor = "green";
      }
    }


    // Filter Status Notar
    const notardata = meetinguser.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "notar" 
    });

    const notarrows = (notardata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

       let inmeetingcolor = "red"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        
        <Tooltip label={fullname}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={fullname} variant="outline" color="dark"  radius="xl" size="md" >
             {initialen} 
          </Avatar> 
      </Indicator>
      </Tooltip>
     
       )
    })

     // Filter Status User
    const userdata = meetinguser.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "user" 
    });

    const userrows = ( userdata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

       let inmeetingcolor = "red"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        
        <Tooltip label={fullname}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={fullname} variant="outline" color="dark"  radius="xl" size="md" >
             {initialen} 
          </Avatar> 
      </Indicator>
      </Tooltip>
     
       )
    })

     // Filter Status Gast
     const guestdata = meetinguser.filter((obj: {isBlocked: any; role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "gast" && !obj.isBlocked
    });

    const guestrows = ( guestdata || []).map((item:any, index:any) => {

        /*let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName*/
        const [username, domain] = item.emailAddress.split('@')[0]
        const initials = username[0].toUpperCase() + domain[0].toUpperCase();

        //let initialen = "GU"
        //let fullname = item.emailAddress

       let inmeetingcolor = "red"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        
 
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={initials} variant="outline" color="dark"  radius="xl" size="md" >
             {initials} 
          </Avatar> 
      </Indicator>
     
     
       )
    })

   
  return (
    <>
     <Grid >
    
      <Grid.Col xs={10} >
        <Group position="left" className={classes.padtop10}>
          <Indicator inline size={10} offset={2} position="bottom-end" color={userstatuscolor} withBorder >
              <Avatar  variant="filled" radius="xl" size="sm">{initialen}</Avatar>
          </Indicator>
            <span><b>{fullname}</b> </span>
        </Group> 
      </Grid.Col>
      <Grid.Col xs={2} >
        <Group position="right" className={classes.padtop10}>  
          <Tooltip label={intl.get('TOOLSVIEW_LOGOUT')} multiline={true}><span> <Logout size={30} strokeWidth={1} color={'black'} onClick={handleLogout}/></span></Tooltip>
        </Group>
      </Grid.Col>
    </Grid>
    <hr /> 
    <Grid >
      <Grid.Col xs={8}  md={8}>
        <Group>
          <Video size={rem(30)} color="gray" />
          <Title order={5}> {meetinginfo.title}</Title>
        </Group>
      </Grid.Col>
      <Grid.Col xs={4} md={4}>
        <Group position="right" >
          <ClientChangeLanguage guestusers={true}/>
        </Group>
      </Grid.Col>
    </Grid>
    <hr />
      <Title order={3}>{intl.get('USERTOOLSVIEW_STRUK_1')}</Title>
    <hr />
      {notarrows}
    <hr />
      <Title order={3}>{intl.get('USERTOOLSVIEW_STRUK_2')}</Title>
    <hr />
      {userrows}

      <Title order={3}>{intl.get('USER_VKGUEST_HEAD')}</Title>
    <hr />
      {guestrows}
      

      

   
    

      <Modal
        title={intl.get('TOOLSVIEW_MODAL_ENDMEETING')}
        opened={logoutopened}
        onClose={handleLogoutclose}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('TOOLSVIEW_MODAL_ENDMEETING_TEXT')}  </Text>
          <hr />
          <Grid>
            <Grid.Col span={6}>
                <Button fullWidth color="green" onClick={handleLogoutYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
                <Button fullWidth color="red" variant="light" onClick={handleLogoutNoClick}>{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
    </>
  );
}

export default GuestToolsView ;